(() => {
  'use strict';
  const key = Symbol.for('seldravinpack.categories.initialize');
  if (window[key]) { window[key](document); return; }
  const instances = new Map();
  function create(root) {
    const host = root.querySelector('[data-category-carousel]');
    const grid = host?.querySelector('.category-grid');
    if (!grid) return null;
    const cards = [...grid.children];
    let config = {};
    try { config = JSON.parse(root.querySelector('[data-category-config]').textContent); } catch {}
    const view = Math.max(1, Number(config.slidesPerView) || 1.2);
    const gap = Math.max(0, Number(config.spaceBetween) || 0);
    const mobile = matchMedia('(max-width:767px)');
    const reduced = matchMedia('(prefers-reduced-motion:reduce)');
    const controller = new AbortController();
    const listen = (node, event, fn) => node.addEventListener(event, fn, { signal: controller.signal });
    let slider = null;
    function reset() {
      slider?.destroy(true, true); slider = null;
      host.classList.remove('swiper'); grid.classList.remove('swiper-wrapper');
      cards.forEach(card => card.classList.remove('swiper-slide'));
    }
    function sync() {
      if (!mobile.matches || !cards.length || typeof window.Swiper !== 'function') { reset(); return; }
      if (slider) { slider.update(); return; }
      host.classList.add('swiper'); grid.classList.add('swiper-wrapper');
      cards.forEach(card => card.classList.add('swiper-slide'));
      slider = new window.Swiper(host, {
        loop: config.loop === true && cards.length >= Math.ceil(view) + 1,
        slidesPerView: view, spaceBetween: gap,
        speed: reduced.matches ? 0 : 320,
        watchOverflow: true, grabCursor: true, a11y: { enabled: true }
      });
    }
    function showCard(card) {
      if (!slider || !card) return;
      const index = cards.indexOf(card); if (index < 0) return;
      if (slider.params.loop) slider.slideToLoop(index, reduced.matches ? 0 : 320);
      else slider.slideTo(index, reduced.matches ? 0 : 320);
    }
    listen(mobile, 'change', sync);
    listen(reduced, 'change', () => { if (slider) { slider.params.speed = reduced.matches ? 0 : 320; slider.originalParams.speed = slider.params.speed; } });
    listen(host, 'focusin', event => showCard(event.target.closest('.category')));
    listen(root, 'shopify:block:select', event => {
      const id = String(event.detail?.blockId || '');
      showCard(cards.find(card => card.dataset.blockId === id || card.contains(event.target)));
    });
    sync();
    return { destroy() { controller.abort(); reset(); } };
  }
  function initialize(scope) {
    const roots = [...scope.querySelectorAll('[data-category-section]')];
    if (scope.matches?.('[data-category-section]')) roots.unshift(scope);
    roots.forEach(root => { if (!instances.has(root)) { const instance = create(root); if (instance) instances.set(root, instance); } });
  }
  function remove(root) { instances.get(root)?.destroy(); instances.delete(root); }
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => { [...instances.keys()].forEach(root => { if (event.target === root || event.target.contains(root)) remove(root); }); });
  new MutationObserver(() => { [...instances.keys()].forEach(root => { if (!root.isConnected) remove(root); }); }).observe(document.documentElement, { childList: true, subtree: true });
  window[key] = initialize;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
})();
